import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {BasePage} from "~/app/pages/base.page";
import {NetworkConnectionType} from "~/app/core/network.service";
import {validEmail, validName} from "~/app/core/util/string-util";
import {CoreService} from "~/app/core/core.service";

@Component({
    selector: "ContactUs",
    templateUrl: "./contact-us.page.html",
    styleUrls: ["./contact-us.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsPage extends BasePage implements OnInit {
    reason: string = "";

    contactName: string = "";
    contactEmail: string = "";
    contactMessage: string = "";

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly route: ActivatedRoute,
        private readonly core: CoreService,
    ) {
        super();
        // Use the component constructor to inject providers.
        // page.actionBarHidden = !ios;
        const userInfo = this.core.api.user_info();
        if (userInfo) {
            this.contactName = userInfo.firstName + " " + userInfo.lastName;
            this.contactEmail = userInfo.email;
        }
    }

    ngOnInit(): void {
        this.reason = this.route.snapshot.paramMap.get("reason");
    }

    goBack() {
        if (!this.waiting) {
            this.waiting = true;
            this.waitingSpinning = false;
        }
    }

    onSubmit() {
        if (!this.waiting) {
            const name = this.contactName;
            const email = this.contactEmail;
            const content = this.contactMessage;
            if (name.length < 3 || !validName(name)) {
                this.core.toast.toastError({
                    header: "Contact Us Problem",
                    message: "Please enter a first and last name."
                });
            } else if (email.length < 3 || !validEmail(email)) {
                this.core.toast.toastError({
                    header: "Contact Us Problem",
                    message: "Please enter a valid email address."
                });
            } else if (content.length < 25) {
                this.core.toast.toastError({
                    header: "Contact Us Problem",
                    message: "Please enter a bit more of a message for us."
                });
            } else {
                if (this.core.net.connectionType === NetworkConnectionType.None) {
                    this.handleNoData("submit");
                } else {
                    this.waiting = true;
                    this.cd.detectChanges();
                    const firstname = name.substr(0, name.indexOf(" ")).trim();
                    const lastname = name.substr(name.indexOf(" ") + 1).trim();
                    this.core.api.user_contactUs(this.reason as ("support"|"merchants"|"sponsors"), firstname, lastname, email, content).then((result) => {
                        if (result.success) {
                            this.waitingSpinning = false;
                            this.core.toast.toastSuccess({
                                header: "Thanks for the message!",
                                message: "We'll get back to you as soon as we can.",
                                onHide: () => {
                                    this.core.nav.navBack();
                                }
                            });
                        } else {
                            this.waiting = false;
                            this.core.toast.toastError({
                                header: "Something went wrong...",
                                message: "Sorry! We're having trouble receiving your message. Please try again."
                            });
                        }
                        this.cd.detectChanges();
                    }, (error) => {
                        this.waiting = false;
                        this.core.toast.toastError({
                            header: "Something went wrong...",
                            message: "Sorry! We're having trouble receiving your message. Please try again."
                        });
                        this.cd.detectChanges();
                    });
                }
            }
        }
    }

    private handleNoData(type: "submit") {
        if (type === "submit") {
            this.core.toast.toastError({
                header: "No Data",
                message: "Sorry! We can't receive your message without data or wi-fi available.\n\nPlease enable data and try again."
            });
        }
    }
}
